import React from "react";
import useProperties from "hooks/useProperties";
import AvgPriceSqMeterChart from "components/Charts/AvgPriceSqMeterChart";
import AverageSquareMeterChart from "components/Charts/AverageSquareMeterChart";
import AverageROIChart from "pages/Dashboard/components/AverageROIChart";
import PropertyDistributionChart from "pages/Dashboard/components/PropertyDistributionChart";

const PropertyDetailChartsSection = () => {
  const { nearbyMarketStatisticsProperties, isFetchingNearbyMarketStatistics } =
    useProperties();

  return (
    <div className="mt-8">
      {!isFetchingNearbyMarketStatistics &&
        nearbyMarketStatisticsProperties?.length > 0 && (
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            <AverageSquareMeterChart
              data={nearbyMarketStatisticsProperties}
              tooltipId="property_details_media_metro_tooltip"
            />
            <AvgPriceSqMeterChart
              data={nearbyMarketStatisticsProperties}
              tooltipId="property_details_price_sq_meter_tooltip"
            />
            <AverageROIChart
              data={nearbyMarketStatisticsProperties}
              tooltipId="property_details_roi_medio_tooltip"
            />
            <PropertyDistributionChart
              data={nearbyMarketStatisticsProperties}
            />
          </div>
        )}
    </div>
  );
};

export default PropertyDetailChartsSection;
